import { render, staticRenderFns } from "./AnularTalonario.vue?vue&type=template&id=4529cb1a"
import script from "./AnularTalonario.vue?vue&type=script&lang=js"
export * from "./AnularTalonario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports